import { STARTAPI_REQUEST_UNSEAL, SENDAPI_REQUEST_UNSEAL } from './constants'

export const startApiRequestUnseal = (message = '') => ({
  type: STARTAPI_REQUEST_UNSEAL,
  message,
})

export const sendApiRequestUnseal = (message = '') => ({
  type: SENDAPI_REQUEST_UNSEAL,
  message,
})
